<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="accountEditor">
        <h2 mat-dialog-title>
            {{Copy && Copy.Id ? 'Modify' : 'Add'}} account
            <mat-icon *ngIf="Copy.ExternalId" class="text-right" matTooltip="Linked with ExactOnline">insert_link</mat-icon>
          <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon>
        </h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="General">
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Default Division</mat-label>
                                <mat-select name="DefaultDivision" [(ngModel)]="Copy.DefaultDivision"
                                            [compareWith]="compareWith" required>
                                  <mat-option *ngFor="let division of _Global.Account.Divisions" [value]="division">
                                    {{division.CompanyName}}
                                  </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <app-relation-selector name="Relation" [(ngModel)]="Copy.Relation"
                                                   placeholder="Relation" [filter]="{where: {TypeId: 'f4ff6940-1181-4bae-9e51-da117326ea50'}}"></app-relation-selector>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Firstname</mat-label>
                              <input [(ngModel)]="Copy.FirstName" matInput name="FirstName"
                                     required>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Lastname</mat-label>
                              <input [(ngModel)]="Copy.LastName" matInput name="LastName"
                                     required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Mobile</mat-label>
                                <input matInput name="Mobile" [(ngModel)]="Copy.Mobile">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Phone</mat-label>
                                <input matInput name="Phone" [(ngModel)]="Copy.Phone">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <mat-form-field>
                          <mat-label>E-mail</mat-label>
                          <input type="email" matInput name="Email" [(ngModel)]="Copy.Email"
                                 required>
                        </mat-form-field>
                      </div>
                      <div class="col-md-6">
                        <mat-form-field>
                          <mat-label>Personel Number</mat-label>
                          <input [(ngModel)]="Copy.ExternalId" matInput name="ExternalId">
                          <mat-hint>Used for the S4 interface</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <app-locale-selector [(ngModel)]="Copy.Locale" [where]="{IsActive: true}" name="Locale" placeholder="Language"
                                                 required></app-locale-selector>
                        </div>
                        <div class="col-6">
                          <app-role-selector [(ngModel)]="Copy.Role" name="Role" placeholder="Role"
                                             required></app-role-selector>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-checkbox name="IsBlocked" [(ngModel)]="Copy.IsActive">Active</mat-checkbox>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Spouse" *ngIf="Copy.MaritalStatus?.Id === '7b59e1d0-07ac-4fbd-b768-95f82f968aef' || Copy.MaritalStatus?.Id === '4c11e285-3254-4f8a-98ea-8773d6bf3bbb'">
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Spouse Firstname</mat-label>
                                <input matInput name="SpouseFirstName" [(ngModel)]="Copy.SpouseFirstName">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Spouse Lastname</mat-label>
                              <input [(ngModel)]="Copy.SpouseLastName" matInput name="SpouseLastName">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Spouse date of birth</mat-label>
                                <input matInput name="spousedob" ngModel [multiple]="true" [(ngModel)]="Copy.SpouseDateOfBirth"
                                       [matDatepicker]="spousedob">
                                <mat-datepicker-toggle matIconSuffix [for]="spousedob"></mat-datepicker-toggle>
                                <mat-datepicker #spousedob></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-checkbox [(ngModel)]="Copy.SpouseIndependent" name="SpouseIndependent">Spouse is Independent</mat-checkbox>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Student" *ngIf="Copy.Role?.Id === 'Student'">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>National Registry Number</mat-label>
                                <input matInput name="NationalRegisterNumber" [(ngModel)]="Copy.NationalRegisterNumber">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Student Until</mat-label>
                                <input matInput name="StudentUntil" ngModel [multiple]="true" [(ngModel)]="Copy.StudentUntil"
                                       [matDatepicker]="studentuntil">
                                <mat-datepicker-toggle matIconSuffix [for]="studentuntil"></mat-datepicker-toggle>
                                <mat-datepicker #studentuntil></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Education & Schools</mat-label>
                                <textarea matInput name="EducationAndSchools" [(ngModel)]="Copy.EducationAndSchools"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Pets</mat-label>
                                <textarea matInput name="Pets" [(ngModel)]="Copy.Pets"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-checkbox [(ngModel)]="Copy.HasCar" name="HasCar">Has Car</mat-checkbox>
                        </div>
                    </div>
                </mat-tab>

                <mat-tab *ngIf="false" label="Address">
                    <!-- temporary disabled, this is not being saved backend-sided -->
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Street</mat-label>
                              <input [(ngModel)]="Copy.Address.Street" matInput name="Street">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Nr.</mat-label>
                                <input matInput name="Number" type="number" [(ngModel)]="Copy.Address.Number">
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Bus</mat-label>
                                <input matInput name="BusNumber" [(ngModel)]="Copy.Address.BusNumber">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field>
                              <mat-label>City</mat-label>
                              <input [(ngModel)]="Copy.Address.City" matInput name="City">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field>
                              <mat-label>Postal Code</mat-label>
                              <input [(ngModel)]="Copy.Address.Postcode" matInput name="Postcode">
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <app-country-selector [(ngModel)]="Copy.Address.Country" placeholder="Country"
                                                  name="Country"></app-country-selector>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Basket">
                    <table class="mat-mdc-table" style="min-width: 400px">
                        <tr>
                            <th>Article</th>
                            <th>Quantity</th>
                            <th>Discount</th>
                            <th style="text-align: right;">
                                <button (click)="picker.Relation = Copy.Relation; picker.open()" mat-icon-button type="button">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </th>
                        </tr>
                        <tbody>
                        <tr *ngFor="let row of Copy.BasketLines">
                            <td>{{row.Article?.Code}}</td>
                            <td>{{row.Ordered}}</td>
                            <td>{{row.Discount | percent}}</td>
                            <td style="text-align: right;">
                                <button (confirm)="removeBasketLine(row)" appConfirmDialog mat-icon-button
                                        type="button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </mat-tab>
              <mat-tab label="Divisions">
                <table class="mat-mdc-table">
                  <tr>
                    <th>Divisie</th>
                    <th>Access</th>
                  </tr>
                  <tbody>
                  <tr *ngFor="let division of Divisions">
                    <td>{{division.CompanyName}}</td>
                    <td>
                      <mat-checkbox (change)="setDivision($event, division);"
                                    [checked]="hasAccess(division, Copy)"></mat-checkbox>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </mat-tab>
                <mat-tab label="Attachments" *ngIf="Copy.Id">
                    <app-attachment-browser [MultiPathes]="[{path: 'Accounts/' + Copy.Id, virtualFolder: Copy.Email}]"></app-attachment-browser>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button [matMenuTriggerFor]="actions" mat-button mat-raised-button type="button">Actions</button>
            <mat-menu #actions="matMenu">
                <button (click)="mkDir();" [disabled]="isLoadingDir" mat-menu-item>
                    Create directory /Accounts/{{Copy.Email}}
                </button>
                <button *ngIf="_Global.hasGUIPermission('ExactOnline')" [disabled]="isLoadingEO" [matMenuTriggerFor]="importExport" mat-menu-item>
                    ExactOnline
                </button>
            </mat-menu>
            <mat-menu #importExport="matMenu">
                <button (click)="linkWithExact()" mat-menu-item>
                    <mat-icon>insert_link</mat-icon>
                    Link with EOL Representative classification
                </button>
            </mat-menu>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>

    <app-account-division-editor #aEditor [(List)]="Copy.AccountDivisions"></app-account-division-editor>
    <app-visual-article-picker #picker (ListChange)="addBasketLines($event);"></app-visual-article-picker>
</ng-template>
